// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__VkJkf","closeSVG":"CloseButton_closeSVG__AZgZ0"};